import { render, staticRenderFns } from "./IcoSkillsDomainLanguage.vue?vue&type=template&id=7a166e3e"
import script from "./IcoSkillsDomainLanguage.vue?vue&type=script&lang=js"
export * from "./IcoSkillsDomainLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports